<template>
  <div id="selectTimeDialog">
    <el-dialog
      :title="$t('EvCharging.ChooseHightTime')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="1220px"
    >
      <div class="content">
        <SelectTimeTable
          v-if="dialogVisible"
          :timeData="timeData"
          @clickTimeRangeSave="clickTimeRangeSave"
          @close="dialogVisible = false"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SelectTimeTable from './SelectTimeTable.vue'
export default {
  components: {
    SelectTimeTable
  },
  props: {
    timeData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    openDialog () {
      this.dialogVisible = true
    },
    clickTimeRangeSave (data) {
      const allEmpty = Object.values(data.formattedWeekActive).every((item) => {
        return item.length <= 0
      })
      if (allEmpty) {
        this.$alert(this.$t('EvCharging.ChooseHightTimeAlertBody'), this.$t('EvCharging.ChooseHightTimeAlertTitle'), {
          confirmButtonText: this.$t('General.OK'),
          type: 'warning',
          callback: action => {}
        })
        return
      }
      const allActive = Object.values(data.formattedWeekInactive).every((item) => {
        return item.length <= 0
      })
      if (allActive) {
        this.$alert(this.$t('EvCharging.AllHightTimeAlertBody'), this.$t('EvCharging.AllHightTimeAlertTitle'), {
          confirmButtonText: this.$t('General.OK'),
          type: 'warning',
          callback: action => {}
        })
        return
      }
      this.$emit('timeRangeSave', data.formattedWeekActive)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  @include basicDialog;
  overflow: auto;
  max-height: 80%;
}
</style>
